(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-info-popover"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.akg-title-row').forEach(function(row) {
      const trigger = row.querySelector('.akg-info-popover-trigger');
      const popover = row.querySelector('.akg-info-popover');
      const closeBtn = row.querySelector('.akg-info-popover__close');

      if (!trigger || !popover) return;

      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        const isOpen = popover.classList.contains('is-open');
        document.querySelectorAll('.akg-info-popover.is-open').forEach(function(p) {
          p.classList.remove('is-open');
          p.setAttribute('aria-hidden', 'true');
        });
        if (!isOpen) {
          popover.classList.add('is-open');
          popover.setAttribute('aria-hidden', 'false');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          popover.classList.remove('is-open');
          popover.setAttribute('aria-hidden', 'true');
          trigger.setAttribute('aria-expanded', 'false');
        });
      }

      document.addEventListener('click', function() {
        popover.classList.remove('is-open');
        popover.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
